import * as React from 'react'
import { Date } from '../Fields/Date'
import { MultipleCheckbox } from '../Fields/MultipleCheckbox'
import { OutlinedInput } from '../Fields/OutlinedInput'
import { DropdownField } from '../Fields/DropdownField'
import { AutocompleteField } from '../Fields/AutocompleteField'
import { ToggleButton } from '../Fields/ToggleButton'
import { LegalTerm } from '../Fields/LegalTerm'
import { LegalStatement } from '../Fields/LegalStatement'
import { GridMultiSelect } from '../Fields/GridMultiSelect'
import { ListSelect } from '../Fields/ListSelect'

export const FieldPicker = ({
  type,
  recaptchaRef,
  setFieldValue,
  ...props
}) => {
  switch (type) {
    case 'date':
      return <Date {...props} />
    case 'multipleCheckbox':
      return <MultipleCheckbox setFieldValue={setFieldValue} {...props} />
    case 'select':
    case 'dropdown':
      return <DropdownField hideLabel {...props} />
    case 'autocomplete':
      return <AutocompleteField hideLabel {...props} />
    case 'toggleButton':
      return <ToggleButton setFieldValue={setFieldValue} {...props} />
    case 'legalTerm':
      return <LegalTerm {...props} />
    case 'legalStatement':
      return <LegalStatement {...props} />
    case 'gridMultiSelect':
      return <GridMultiSelect {...props} />
    case 'listSelect':
      return <ListSelect {...props} />
    case 'captchaVerification':
      return
    default:
      return <OutlinedInput {...props} />
  }
}
